import { layer } from "azure-maps-control";
import { renderToString } from "react-dom/server";
import { getMarkerIcon, symbolLayerIconConfig } from "./insMarkerIcons";
export const constMap = {
    CLUSTER_BREAK_POINT_1: 15,
    CLUSTER_BREAK_POINT_2: 30,
    CLUSTER_BREAK_POINT_3: 45,
    CLUSTER_BREAK_POINT_4: 60,
    CLUSTER_MAX_PIXELS: 10000,
    CLUSTER_RADIUS: 50,
    NUMBER_OF_MARKERS: 11,
    NUMBER_OF_MARKERS_QUARTILE: 5,
    PIXEL_OFFSET: -18,
    TEXT_OFF_SET: 0.4
};
export const getIconPromises = (colorSet) => {
    const iconPromises = [];
    const numberOfMarkers = colorSet === "quartile" ? constMap.NUMBER_OF_MARKERS_QUARTILE : constMap.NUMBER_OF_MARKERS;
    for (let i = 0; i < numberOfMarkers; i += 1) {
        iconPromises.push({ icon: renderToString(getMarkerIcon(i, colorSet)), id: `marker-icon-${i.toString()}` });
    }
    return iconPromises;
};
export const optionsSymbolLayer = { filter: ["!", ["has", "point_count"]],
    iconOptions: {
        allowOverlap: true,
        image: symbolLayerIconConfig
    } };
export const optionsCountSymbolLayer = {
    iconOptions: {
        image: "none"
    },
    textOptions: {
        color: "white",
        offset: [0, constMap.TEXT_OFF_SET],
        textField: ["get", "point_count_abbreviated"]
    }
};
export const optionsClusterLayer = {
    cluster: true,
    clusterMaxZoom: 15,
    clusterRadius: constMap.CLUSTER_RADIUS
};
export const getCountOfLocationLayer = (dataSource) => new layer.SymbolLayer(dataSource, undefined, {
    iconOptions: {
        image: "none"
    },
    textOptions: {
        color: "white",
        offset: [0, constMap.TEXT_OFF_SET],
        textField: ["get", "point_count_abbreviated"]
    }
});
export const optionsBubbleLayer = {
    filter: ["has", "point_count"],
    radius: [
        "step",
        ["get", "point_count"],
        constMap.CLUSTER_BREAK_POINT_1,
        100,
        constMap.CLUSTER_BREAK_POINT_2,
        1000,
        constMap.CLUSTER_BREAK_POINT_3,
        constMap.CLUSTER_MAX_PIXELS,
        constMap.CLUSTER_BREAK_POINT_4
    ],
    strokeWidth: 0
};
